import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { NetPingDeviceFindManyQueryInterface } from '@zaoblako/shared/modules/pacs/dtos/net-ping-device/net-ping-device-find-many-query.dto';
import type { NetPingDevicePageInterface } from '@zaoblako/shared/modules/pacs/dtos/net-ping-device/net-ping-device-page.dto';
import type { NetPingDeviceFindInterface } from '@zaoblako/shared/modules/pacs/dtos/net-ping-device/net-ping-device-find.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { ReportItemsPageInterface } from '@zaoblako/shared/common/dtos/report/report-items-page.dto';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetPingDeviceService extends BaseService {
  protected baseUrl = '/pacs/base/net-ping-device';

  public findMany(query?: NetPingDeviceFindManyQueryInterface): Observable<NetPingDevicePageInterface> {
    return this.http.get<NetPingDevicePageInterface>(this.baseUrl, {
      params: query ? this.objectToHttpParams(query) : {}
    });
  }

  public findPage(query?: NetPingDeviceFindManyQueryInterface): Observable<ReportItemsPageInterface<NetPingDeviceFindInterface>> {
    return this.http.get<ReportItemsPageInterface<NetPingDeviceFindInterface>>(`${this.baseUrl}/items`, {
      params: query ? this.objectToHttpParams(query) : {}
    });
  }

  public getRegistryDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(`${this.baseUrl}/registry-descriptor`);
  }

  public restoreOne(id: number): Observable<NetPingDeviceFindInterface> {
    return this.http.post<NetPingDeviceFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }

  public getHistoryForOne(id: number, query?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: query
        ? this.objectToHttpParams(query)
        : {}
    });
  }
}
